import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {injectIntl} from 'react-intl';

import {ControllerContainer} from '@stubhub/react-store-provider';

import produceController from './controller';

import ConnectedEventListPanel from './index';

class EventListPanelContainer extends Component {
  constructor(props, context) {
    super(props, context);
  }

  render() {
    const childProps = {...this.props};
    delete childProps.intl; // Child component doesn't need intl prop, which may cause rerender

    return <ControllerContainer component={ConnectedEventListPanel} factory={produceController} {...childProps} />;
  }
}

EventListPanelContainer.propTypes = {
  defaultSort: PropTypes.string,
  sortOptions: PropTypes.array,
  intl: PropTypes.object,
  id: PropTypes.any, // Used to check if need to reset the component
  includeRadius: PropTypes.bool,
};
EventListPanelContainer.defaultProps = {
  defaultSort: 'date',
  includeRadius: true,
};

export default injectIntl(EventListPanelContainer);
